
/**
 * @Name: 个人中心 service
 */

import request from '../request'
import apis from '../apis'

export default {

    /**
     * 根据当前登录人的用户ID查询是否已同意隐私
     * @param {*} params
     */
    findUserAgreeStatusSer(params) {
        return request.post(`${apis.SELECT_AGREE_STATUS}`, params)
    },
    getPrivacyVersionSer(params) {
        return request.get(apis.GET_PRIVACY_VERSION, params)
    },

    /**
     * 同意隐私收集
     * @param {*} params
     */
    saveUserConcealSer(params) {
        return request.post(`${apis.SAVE_USER_CONCEAL}`, params)
    },

    /**
     * 拒绝隐私收集
     * @param {*} params
     */
    updateConcealStatusSer(params) {
        return request.post(`${apis.UPDETE_CONCEAL_STATUS}`, params)
    },

    /**
     * 删除单条导入记录
     * @param {*} params
     */
    deleteImportSer(params) {
        return request.post(`${apis.DELETE_IMPORT}`, params)
    },

    /**
     * 删除单条导出记录
     * @param {*} params
     */
    deleteExportSer(params) {
        return request.post(`${apis.DELETE_EXPORT}`, params)
    },

    /**
     * 获取个人信息数据
     * @param {*} params
     */
    findPersonalUser(params) {
        return request.get(`${apis.FIND_PERSONAL_USER}`, { params });
    },

    /**
     * 更新个人信息数据
     * @param {*} params
     */
    saveOrUpdatePersonalUser(params) {
        return request.post(`${apis.SAVE_OR_UPTATE_PERSONAL_USER}`, params)
    },

    /**
     * 分页查询查询常用联系人列表
     * @param {*} params
     */
    findContactPageList({ pageVO, params }) {
        return request.get(`${apis.FIND_CONTACT_PAGE_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },

    /**
     * 保存常用联系人
     * @param {*} params
     */
    saveContactInfo(params) {
        return request.post(`${apis.SAVE_CONTACT_INFO}`, params)
    },

    /**
     * 查询常用联系人详情
     * @param {*} params
     */
    findContactDetailById(params) {
        return request.get(`${apis.FIND_CONTACT_DETAIL_BY_ID}`, { params });
    },

    /**
     * 删除常用联系人
     * @param {*} params
     */
    delContactInfoById(params) {
        return request.get(`${apis.DEL_CONTACT_DETAIL_BY_ID}`, { params });
    },

    /**
     * 根据ID查询常用地址
     * @param {*} params
     */
    findFavoriteAddress(params) {
        return request.get(`${apis.DIND_FAVORITE_ADDRESS}`, { params });
    },

    /**
     * 常用地址分页查询接口
     * @param {*} params
     */
    findFavoriteAddressPagedList({ pageVO, params }) {
        return request.get(`${apis.DIND_FAVORITE_ADDRESS_PAGED_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },

    /**
     * 新增或更新常用地址
     * @param {*} params
     */
    saveOrUpdateFavoriteAddress(params) {
        return request.post(`${apis.SAVE_OR_UPTATE_FAVORITE_ADDRESS}`, params)
    },

    /**
     * 删除常用地址
     * @param {*} params
     */
    deleteFavoriteAddress(params) {
        return request.post(`${apis.DELETE_FAVORITE_ADDRESS}`, params)
    },

    /**
     * 根据ID查询常用发票
     * @param {*} params
     */
    getInvoiceInfo(params) {
        return request.get(`${apis.GET_INVOICE_INFO}`, { params });
    },

    /**
     * 常用发票分页查询接口
     * @param {*} params
     */
    getInvoiceList({ pageVO, params }) {
        return request.get(`${apis.GET_INVOICE_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },

    /**
     * 新增或更新常用发票
     * @param {*} params
     */
    addOrUpdateInvoice(params) {
        return request.post(`${apis.ADD_OR_UODATE_INVOICE}`, params)
    },

    /**
     * 删除常用发票
     * @param {*} params
     */
    deleteInvoice(params) {
        return request.get(`${apis.DELETE_INVOICE}`, { params });
    },
    findContact2(params) {
        return request.get(`${apis.FIND_CONTACT2}`, params)
    },

    /**
     * 获取我的导入数据
     * @param {*} params
     */
    getMyImportListData({ pageVO, params }) {
        return request.get(`${apis.GET_MY_IMPORT_DATA}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },

    /**
     * 获取我的导出数据
     * @param {*} params
     */
    getMyExportListData({ pageVO, params }) {
        return request.get(`${apis.GET_MY_EXPORT_DATA}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    }
}
